class WindowLocationInstance {
  get hash() {
    return window.location.hash;
  }
  get host() {
    return window.location.host;
  }
  get hostname() {
    return window.location.hostname;
  }
  get href() {
    return window.location.href;
  }
  get origin() {
    return window.location.origin;
  }
  get pathname() {
    return window.location.pathname;
  }
  get port() {
    return window.location.port;
  }
  get protocol() {
    return window.location.protocol;
  }
  get search() {
    return window.location.search;
  }
  ancestorOrigins() {
    return window.location.ancestorOrigins;
  }
  assign(url) {
    window.location.assign(url);
  }
  reload() {
    window.location.reload();
  }
  replace(url) {
    window.location.replace(url);
  }
}
const WindowLocation = new WindowLocationInstance();
export {
  WindowLocation,
  WindowLocationInstance
};
//# sourceMappingURL=WindowService.js.map
